import IndividualDevelopmentPlan from './model';
import create from './create';

IndividualDevelopmentPlan.create = create;

export default IndividualDevelopmentPlan;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/Idp/index.js